import React, { useEffect, useState } from "react";
import axios from "axios";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import { BsThreeDotsVertical } from "react-icons/bs";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import AnimateButton from "../utils/AnimateButton";
import Popover from "@mui/material/Popover";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import List from "@mui/material/List";
import { Divider } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import { Modal, IconButton } from "@mui/material";
import { MdPrint, MdClose } from "react-icons/md";
import Android from "../../assets/images/android.png";
import Web from "../../assets/images/web.png";
import "./../../assets/style.css";
import { FaApple, FaAndroid, FaGlobe } from "react-icons/fa";
// import ListItemButton from "@mui/material/ListItemButton";
import Collapse from "@mui/material/Collapse";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { useAuth } from "../../contextApi/ContextApi";
import { Navigate, useNavigate } from "react-router-dom";
import ModalSec from "./Modal";
import Swal from "sweetalert2";
import { div } from "framer-motion/client";
import { baseURL } from "../../../src/constants/index";

const Details = ({ selectedButton }) => {
  const { filter } = useAuth();
  const [openPrint, setOpenPrint] = useState(false);
  const [printUrl, setPrintUrl] = useState("");

  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [openList, setOpenList] = React.useState(null);
  const [prepare, setPrepare] = React.useState(false);
  const [orderDataList, setOrderDataList] = React.useState([]);
  const [orderList, setOrderList] = React.useState([]);

  const [orderAccepted, setOrderAccepted] = React.useState(false);
  const [orderpreparing, setOrderPreparing] = React.useState(false);
  const [orderReady, setOrderReady] = React.useState(false);
  const [orderasign, setOrderAsign] = React.useState(false);
  const [deliveryBoyList, setDeliveryBoyList] = React.useState([]);
  const [orderCancelled, setOrderCancelled] = React.useState(false);
  const [openModal, setOpenModal] = React.useState(false);
  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);
  const storedData = JSON.parse(localStorage.getItem("LoginData"));

  const handleListClick = (index) => {
    setOpenList(openList === index ? null : index);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  // const handlePrepare = () => {
  //   setPrepare(!prepare);
  // };
  console.log(storedData);
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const login = async () => {
    try {
      const config = {
        "Content-Type": "application/json",
      };

      const Id = localStorage.getItem("deviceId");

      const res = await axios.post(
        `${baseURL}/Teamlogin`,
        {
          MobileNo: storedData.MobileNo,
          LoginPassword: storedData.password,
          IsDevMode: true,
          DeviceId: Id,
        },
        config,
      );

      if (res.data.Status === 1) {
        console.log("activated");
      } else {
        localStorage.removeItem("LoginData");
        navigate("/login");
      }
    } catch (err) {
      console.log(err);
    }
  };

  const fetchData = async () => {
    try {
      const config = {
        "Content-Type": "application/json",
      };
      setLoading(true);
      const res = await axios.post(
        `https://thekrish.in/api/cryptographyapi/CurrentOrderDashboard_Kitchen
        `,
        config,
      );
      if (res.data.Status === 1) {
        setOrderDataList(res.data.Data);
        // console.log(res.data.Data);
        setLoading(false);
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
    login();
  }, []);

  // console.log(storedData?.UserName);
  const OrderStatus = async (orderid, status) => {
    console.log(orderid);
    try {
      const config = {
        "Content-Type": "application/json",
      };

      const res = await axios.post(
        `https://thekrish.in/api/cryptographyapi/ChangeOrderStatusnew
      `,
        {
          OrderId: orderid,
          OrderStatus: status,
          AcceptedBy: storedData?.UserName,
        },
        config,
      );
      if (res.data.Status === 1) {
        // console.log(res.data.Data);
        // setOrderAccepted(true);

        window.alert(`your order is ${status}`);
      }
    } catch (error) {
      console.log(error);
    }

    fetchData();
  };

  const CancelOrder = async (id) => {
    try {
      // Step 1: Confirmation popup
      const confirmResult = await Swal.fire({
        title: "Are you sure?",
        text: "Do you want to cancel this order?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, Cancel",
        cancelButtonText: "No",
      });

      if (!confirmResult.isConfirmed) return;

      // Step 2: Remark input popup
      const remarkResult = await Swal.fire({
        title: "Cancel Remark",
        input: "text",
        inputPlaceholder: "Enter cancel remark",
        showCancelButton: true,
        confirmButtonText: "Submit",
        inputValidator: (value) => {
          if (!value) {
            return "Cancel remark is required!";
          }
        },
      });

      if (!remarkResult.isConfirmed) return;

      const cancelRemark = remarkResult.value;
      setLoading(true);
      // Step 3: API call
      const res = await axios.post(
        "https://thekrish.in/api/cryptographyapi/ChangeOrderStatusnew",
        {
          OrderId: id,
          OrderStatus: "Cancelled",
          CancelRemark: cancelRemark,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      // Step 4: Success alert
      if (res.data.Status === 1) {
        Swal.fire("Cancelled!", "Your order has been cancelled.", "success");
      } else {
        Swal.fire("Failed", "Unable to cancel order.", "error");
      }
    } catch (error) {
      console.error(error);
      Swal.fire("Error", "Something went wrong!", "error");
    }
    setLoading(false);
    fetchData();
  };

  const handleOrderReady = () => {
    window.alert("your order is ready now");

    setOrderReady(true);
  };
  const preparingOrder = async () => {
    try {
      const config = {
        "Content-Type": "application/json",
      };

      const res = await axios.post(
        `https://thekrish.in/api/cryptographyapi/ChangeOrderStatusnew
      `,
        {
          OrderId: 1,
          OrderStatus: "preparing",
        },
        config,
      );
      if (res.data.Status === 1) {
        console.log(res.data.Data);
        // setOrderPreparing(true);
        window.alert("your order is preparing");
      }
    } catch (error) {
      console.log(error);
    }
  };

  const [assignId, setAssignId] = useState(null);
  const getDeliveryBoyList = async (id) => {
    setLoading(true);

    try {
      const config = {
        "Content-Type": "application/json",
      };

      const res = await axios.post(
        `https://thekrish.in/api/cryptographyapi/DeliveryBoys_Kitchen
      `,
        config,
      );
      if (res.data.Status === 1) {
        // console.log(res.data.Data);
        handleOpenModal();
        setDeliveryBoyList(res.data.Data);
        setAssignId(id);
        setOrderAsign(true);
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    let data = [];
    console.log(filter);
    if (filter === "All" || !filter) {
      data = orderDataList;
    } else if (filter === "Pending") {
      data = orderDataList.filter(
        (item) =>
          item.OrderStatus !== "Delivered" && item.OrderStatus !== "Cancelled",
      );
    } else if (filter === "Scheduled") {
      data = orderDataList.filter((item) => item.IsScheduled === true);
    } else {
      data = orderDataList.filter((item) => item.OrderStatus === filter);
    }
    console.log(data);
    setOrderList(data);
  }, [filter, orderDataList]);

  // useEffect(() => {
  //   const data = orderDataList.filter((item, i) => {
  //     return filter === "All" || filter == null
  //       ? true
  //       : item.OrderStatus === filter;
  //   });
  //   setOrderList(data);
  //   console.log(data);
  // }, [filter, orderDataList]);

  const getStatusColor = (status) => {
    switch (status) {
      case "Delivered":
        return "#28a745"; // green
      case "Pending":
        return "#007bff"; // red
      case "Cancelled":
        return "#ff0000ff"; // blue
      default:
        return "#6c757d"; // gray fallback
    }
  };

  const getDeliveryTime = (orderDate, statusDate) => {
    if (!orderDate || !statusDate) return "";

    const year = new Date().getFullYear();
    const start = new Date(`${orderDate} ${year}`);
    const end = new Date(`${statusDate} ${year}`);

    const diffMs = end - start;
    if (isNaN(diffMs) || diffMs <= 0) return "";

    const totalMinutes = Math.floor(diffMs / (1000 * 60));
    if (totalMinutes <= 0) return "";

    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    return hours > 0 ? `${hours} hr ${minutes} min` : `${minutes} min`;
  };

  return (
    <Box className="mt-3">
      {loading && (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",

            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999999999,
          }}
        >
          <CircularProgress color="inherit" />
        </Box>
      )}

      {orderList && orderList.length ? (
        orderList.map((item, index) => (
          <Card
            variant="outlined"
            className="p-2 mb-2 css-1v5z4dq-MuiPaper-root-MuiCard-root"
            key={index}
            style={{
              boxShadow: "rgb(0 0 0 / 21%) 0px -1px 20px 1px",
              backgroundColor: item?.IsScheduled
                ? "rgb(255 215 119 / 47%)"
                : "#ffffff",
            }}
          >
            <Grid
              container
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              className="mb-1"
            >
              <Typography
                variant="div"
                color="initial"
                sx={{ marginRight: "8px" }}
                className="css-1sqs2sb-MuiTypography-root"
              >
                <span
                  className="px-2 py-1 rounded"
                  style={{
                    backgroundColor: getStatusColor(item.OrderStatus),
                    color: "white",
                    marginRight: "6px",
                    fontSize: "11px",
                    fontWeight: "700",
                  }}
                >
                  {item.OrderStatus}
                </span>
              </Typography>
              <Grid
                item
                xs={2}
                className="d-flex align-items-center justify-content-center"
                style={{ gap: "8px" }} // no gap
              >
                {/* PRINT BUTTON */}
                <Button
                  onClick={() => {
                    setPrintUrl(
                      `https://thekrish.in/Admin/Report/ThermalPrint/${item?.Id}`,
                    );
                    setOpenPrint(true);
                  }}
                  style={{
                    borderRadius: "50%",
                    color: "#000000",
                    fontFamily: "poppins",
                    padding: "4px",
                    minWidth: "unset", // important
                    background: "#0000003d",
                  }}
                >
                  <MdPrint size={20} />
                </Button>

                {/* ORDER TYPE ICON */}
                {item?.OrderType && (
                  <div
                    className=" pb-1 triangle-badge d-flex align-items-center justify-content-center"
                    style={{
                      borderRadius: "50%",
                      color: "#000000",
                      fontFamily: "poppins",
                      padding: "4px",
                      minWidth: "unset", // important
                      background: "#0000003d",
                    }}
                  >
                    {item?.OrderType === "IOS" && <FaApple size={20} />}
                    {item?.OrderType === "Android" && (
                      <img
                        src={Android}
                        alt="Android"
                        style={{ width: "22px", display: "block" }}
                      />
                    )}
                    {item?.OrderType === "Web" && (
                      <img
                        src={Web}
                        alt="Web"
                        style={{ width: "22px", display: "block" }}
                      />
                    )}
                  </div>
                )}
              </Grid>

              <Typography
                variant="div"
                color="initial"
                className="css-1boddzg-MuiTypography-root"
                style={{ fontWeight: "700" }}
              >
                ID : <span style={{ fontSize: "16px" }}>#{item.Id}</span>
              </Typography>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Typography
                variant="div"
                color="initial"
                className="css-1boddzg-MuiTypography-root"
              >
                {/* <span
                  className=" px-2 py-1 rounded"
                  style={{
                    backgroundColor: "#ff0303ff",
                    color: "white",
                    marginRight: "6px",
                  }}
                >
                  {item.OrderStatus}
                </span> */}
                <span
                  className="text-success"
                  style={{ fontSize: "12px", fontWeight: "700" }}
                >
                  {item.UserName}'s {item.OrderNo} order
                </span>
              </Typography>
              <Typography
                variant="div"
                color="initial"
                className="css-1boddzg-MuiTypography-root"
                style={{ fontWeight: "700" }}
              >
                {item.OrderDate}
                {/* <BsThreeDotsVertical
                  onClick={handleClick}
                  className="m-1"
                  style={{ cursor: "pointer" }}
                /> */}
                <Popover
                  id={id}
                  // open={open}
                  anchorEl={anchorEl}
                  onClose={handleClose}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                >
                  <List>
                    <ListItem button onClick={handleClose}>
                      <ListItemText primary="Action" />
                    </ListItem>
                    <ListItem button onClick={handleClose}>
                      <ListItemText primary="Another action" />
                    </ListItem>
                    <ListItem button onClick={handleClose}>
                      <ListItemText primary="Something else" />
                    </ListItem>
                  </List>
                </Popover>
              </Typography>
            </Grid>
            <Grid
              container
              justifyContent="space-between"
              alignItems="center"
              className="border-top"
            >
              <List sx={{ width: "100%" }}>
                {/* HEADER */}
                <Grid
                  container
                  justifyContent="space-between"
                  alignItems="center"
                  marginBottom="10px"
                  onClick={() => handleListClick(`items-${index}`)}
                  sx={{ cursor: "pointer" }}
                  className="css-q7gepv-MuiGrid-root css-1lqyr90"
                >
                  <Typography
                    fontWeight="600"
                    className="css-1qqynwt-MuiTypography-root"
                  >
                    Items Details ({item.OrderDetails?.length || 0})
                  </Typography>

                  {openList === `items-${index}` ? (
                    <ExpandLess />
                  ) : (
                    <ExpandMore />
                  )}
                </Grid>

                {/* COLLAPSE */}
                <Collapse
                  in={openList === `items-${index}`}
                  timeout="auto"
                  unmountOnExit
                >
                  <List disablePadding>
                    {/* PRODUCTS */}
                    {item.OrderDetails?.map((product, i) => (
                      <Grid
                        key={i}
                        container
                        justifyContent="space-between"
                        alignItems="center"
                        marginBottom="8px"
                        className="css-1lqyr90 "
                      >
                        <Typography
                          fontSize="13px"
                          className="css-qybatc-MuiTypography-root"
                        >
                          {product.Qty} × {product.Catalog}{" "}
                          <span style={{ color: "#717dba", fontSize: "11px" }}>
                            {product.Size}
                          </span>
                        </Typography>

                        <Typography
                          fontSize="13px"
                          className="css-qybatc-MuiTypography-root"
                        >
                          ₹{product.Price * product?.Qty}
                        </Typography>
                      </Grid>
                    ))}

                    {/* TOTAL QTY */}
                    <Divider sx={{ my: 1 }} />

                    {/* <Grid
          container
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography fontWeight="600">
            Total Quantity
          </Typography>
          <Typography fontWeight="600">
            {totalQty}
          </Typography>
        </Grid> */}
                  </List>
                </Collapse>
              </List>
            </Grid>

            <Grid
              container
              justifyContent="space-between"
              alignItems="center"
              className="border-top "
            >
              <List
                sx={{ width: "100%", bgcolor: "background.paper" }}
                component="nav"
                className={` ${item?.IsScheduled ? "scheduled-order" : ""}`}
                aria-labelledby="nested-list-subheader"
              >
                <Grid
                  container
                  justifyContent="space-between"
                  alignItems="center"
                  sx={{ paddingX: "px" }}
                  marginBottom={"10px"}
                  onClick={() => handleListClick(index)}
                  className="css-qkzja-MuiGrid-root"
                >
                  <Typography
                    variant="div"
                    color="initial"
                    className="css-1boddzg-MuiTypography-root"
                  >
                    Total Bill:
                  </Typography>
                  <Typography variant="div" color="textSecondry">
                    <span style={{ fontSize: "18px", fontWeight: "700" }}>
                      &#8377;{item.NetAmount}{" "}
                    </span>
                    <span
                      className="text-success"
                      style={{ fontSize: "14px", fontWeight: "700" }}
                    >
                      ({item.PayMode})
                    </span>{" "}
                    {openList === index ? <ExpandLess /> : <ExpandMore />}
                  </Typography>
                </Grid>
                <Collapse in={openList === index} timeout="auto" unmountOnExit>
                  <List
                    component="div"
                    disablePadding
                    style={{ fontSize: "11px !important" }}
                  >
                    <Grid
                      container
                      justifyContent="space-between"
                      alignItems="center"
                      sx={{ paddingX: "px" }}
                      style={{ fontSize: "11px !important" }}
                    >
                      <div
                        variant="div"
                        color="initial"
                        style={{ fontSize: "11px", fontWeight: "700" }}
                      >
                        Total Amount
                      </div>
                      <div
                        variant="div"
                        color="textSecondry"
                        style={{ fontSize: "11px", fontWeight: "700" }}
                      >
                        &#8377;{item.TotalAmount}
                      </div>
                    </Grid>
                    <Grid
                      container
                      justifyContent="space-between"
                      alignItems="center"
                      sx={{ paddingX: "px" }}
                    >
                      <div
                        variant="div"
                        color="initial"
                        style={{ fontSize: "11px", fontWeight: "700" }}
                      >
                        Tax Amount
                      </div>
                      <div
                        variant="div"
                        color="textSecondry"
                        style={{ fontSize: "11px", fontWeight: "700" }}
                      >
                        &#8377;{item.TaxAmount}
                      </div>
                    </Grid>
                    <Grid
                      container
                      justifyContent="space-between"
                      alignItems="center"
                      sx={{ paddingX: "px" }}
                    >
                      <div
                        variant="div"
                        color="initial"
                        style={{ fontSize: "11px", fontWeight: "700" }}
                      >
                        Delivery Charge:
                      </div>
                      <div
                        variant="div"
                        color="textSecondry"
                        style={{ fontSize: "11px", fontWeight: "700" }}
                      >
                        &#8377;{item.ShippingCharge}
                      </div>
                    </Grid>
                    <Grid
                      container
                      justifyContent="space-between"
                      alignItems="center"
                      className="text-red"
                      sx={{ paddingX: "px", color: "red" }}
                    >
                      <div
                        variant="div"
                        color="textSecondry"
                        style={{ fontSize: "11px", fontWeight: "700" }}
                      >
                        Discount:
                      </div>
                      <div
                        variant="div"
                        color="textSecondry"
                        style={{ fontSize: "11px", fontWeight: "700" }}
                      >
                        &#8377;{item.Discount}
                      </div>
                    </Grid>
                  </List>
                </Collapse>
              </List>
            </Grid>

            {item?.SpecialRemarks && (
              <Grid
                className=" border-top"
                style={{ fontSize: "12px", fontWeight: "600" }}
              >
                <p className="mb-0 py-2">
                  Special Remark :{" "}
                  <span className="text-danger">{item?.SpecialRemarks}</span>
                </p>
              </Grid>
            )}
            {item?.IsScheduled && (
              <Grid
                className=" border-top"
                style={{ fontSize: "12px", fontWeight: "600" }}
              >
                <p
                  className=" mb-2 mt-2 border rounded-2"
                  style={{ background: "#fff", textAlign: "center" }}
                >
                  ⏰ Schedule Date & Time :{" "}
                  <span className="text-danger">{item?.SdlCreateDate}</span>
                </p>
              </Grid>
            )}

            <Grid container columnSpacing={2} mt={0}>
              {item.OrderStatus === "Pending" && (
                <Grid item xs={9}>
                  <AnimateButton>
                    <Button
                      fullWidth
                      variant="contained"
                      onClick={() => OrderStatus(item?.Id, "Accepted")}
                      style={{ fontFamily: "poppins" }}
                    >
                      Accept
                    </Button>
                  </AnimateButton>
                </Grid>
              )}

              {item.OrderStatus === "Accepted" && (
                <Grid item xs={7}>
                  <AnimateButton>
                    <Button
                      fullWidth
                      variant="contained"
                      color="warning"
                      onClick={() => OrderStatus(item.Id, "Preparing")}
                      style={{ fontFamily: "poppins" }}
                    >
                      Preparing
                    </Button>
                  </AnimateButton>
                </Grid>
              )}

              {item.OrderStatus === "Preparing" && (
                <Grid item xs={9}>
                  <AnimateButton>
                    <Button
                      fullWidth
                      variant="contained"
                      color="success"
                      onClick={() => OrderStatus(item.Id, "OrderReady")}
                      style={{ fontFamily: "poppins" }}
                    >
                      Order Ready
                    </Button>
                  </AnimateButton>
                </Grid>
              )}

              {item.OrderStatus === "OrderReady" && (
                <Grid item xs={9}>
                  <AnimateButton>
                    <Button
                      fullWidth
                      variant="contained"
                      color="info"
                      onClick={() => getDeliveryBoyList(item.Id, "Assigned")}
                      style={{ fontFamily: "poppins" }}
                    >
                      Assign
                    </Button>
                  </AnimateButton>
                </Grid>
              )}

              {item.OrderStatus === "Assigned" && (
                <Grid item xs={9}>
                  <AnimateButton>
                    <Button
                      fullWidth
                      variant="contained"
                      color="secondary"
                      onClick={() => OrderStatus(item.Id, "Delivered")}
                      style={{ fontFamily: "poppins" }}
                    >
                      Out For Delivery
                    </Button>
                  </AnimateButton>
                </Grid>
              )}
              {/* {item.OrderStatus === "Delivered" && (
                <Grid item xs={12}>
                  <AnimateButton>
                    <Button
                      fullWidth
                      variant="contained"
                      color="secondary"
                      // onClick={() => OrderStatus(item.OrderId,"Delivered")}
                      style={{ fontFamily: "poppins" }}
                    >
                      Delivered
                    </Button>
                  </AnimateButton>
                </Grid>
              )} */}

              {item.OrderStatus !== "Cancelled" &&
                item.OrderStatus !== "Delivered" && (
                  <Grid item xs={3}>
                    <AnimateButton>
                      <Button
                        fullWidth
                        variant="contained"
                        style={{
                          backgroundColor: "red",
                          color: "#fff",
                          fontFamily: "poppins",
                        }}
                        onClick={() => CancelOrder(item.Id)}
                      >
                        Cancel
                      </Button>
                    </AnimateButton>
                  </Grid>
                )}
            </Grid>

            <div
              style={{
                textAlign: "start",
                fontSize: "13px",
                fontWeight: "700",
                marginTop: "5px",
                borderBottom: "1px solid #e4dadae8",
              }}
            >
              {item?.AssignDetails?.UserName && (
                <div className="d-flex align-items-center justify-content-between">
                  <div>
                    {item.OrderStatus !== "Delivered"
                      ? " Assigned to :"
                      : " Delivered by :"}
                  </div>
                  <div
                    style={{
                      color: "red",
                      fontSize: "15px",
                    }}
                  >
                    {item?.AssignDetails?.UserName}
                  </div>
                </div>
              )}
            </div>

            {filter === "Delivered" && (
              <div
                style={{
                  textAlign: "center",
                  fontSize: "13px",
                  fontWeight: "700",
                  marginTop: "5px",
                }}
              >
                {item?.OrderDate &&
                  item?.OrderStatusDate &&
                  getDeliveryTime(item.OrderDate, item.OrderStatusDate) && (
                    <div>
                      Order Delivered in{" "}
                      {getDeliveryTime(item.OrderDate, item.OrderStatusDate)}
                    </div>
                  )}
              </div>
            )}
          </Card>
        ))
      ) : (
        <div></div>
      )}

      {orderList && orderList.length === 0 && !loading && (
        <p className="no-order" style={{ background: "white" }}>
          No New Order(s) Found
        </p>
      )}
      <Modal
        open={openPrint} // 🔥 controlled here
        onClose={() => setOpenPrint(false)}
      >
        <Box
          sx={{
            width: "90%",
            height: "90%",
            margin: "auto",
            marginTop: "15px",
            borderRadius: "10px",
            background: "#fff",
          }}
        >
          <IconButton onClick={() => setOpenPrint(false)}>
            <MdClose />
          </IconButton>

          <iframe
            src={printUrl}
            width="100%"
            height="100%"
            style={{ border: "none" }}
          />
        </Box>
      </Modal>

      <ModalSec
        open={openModal}
        close={handleCloseModal}
        assignId={assignId}
        fetchData={fetchData}
        deliveryBoyList={deliveryBoyList}
      />
    </Box>
  );
};

export default Details;
